import React from 'react';

import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef} from '../../../lib/react/higher-order-components';
import {OEViewType} from '../../../lib/oe-types';
import OENotification from '../../../lib/notification/oe-notification';
import {OEInfoMessageViewType, OEInfoMessageViewProps} from './oe-info-message-model';
import {OEInfoMessageStdController} from './oe-info-message-view-std';

export function OEInfoMessageViewFactory(props) {
    let {fref, ...rest} = props;

    const openFn = (sender, isOpen) => {
        if(!props.appComponent || !props.appComponent.uiLayer) return;
        props.appComponent.uiLayer.notificationCenter.post(OENotification.viewOpenStateChanged, {
            type:       OEViewType.customExt,
            isOpen:     isOpen,
            sender:     sender
        });
    };

    if(props.target && props.config.filter)    {
        const filter = props.config.filter;
        if((typeof(filter.includeTargets) === 'string' && filter.includeTargets !== props.target) || (Array.isArray(filter.includeTargets) && !filter.includeTargets.includes(props.target)))  return null;
        if((typeof(filter.excludeTargets) === 'string' && filter.excludeTargets === props.target) || (Array.isArray(filter.excludeTargets) && filter.excludeTargets.includes(props.target)))  return null;
    }

    if(props.config.type == OEInfoMessageViewType.std) {
        return <OEInfoMessageStdController {...rest} ref={fref} onOpenStateChanged={openFn}/>;
    }

    return null;
}

OEInfoMessageViewFactory.defaultProps = OEInfoMessageViewProps.defaultProps;

OEInfoMessageViewFactory.propTypes = OEInfoMessageViewProps.propTypes;

export default frefFromRef(connectAppEnv((env) => { return {
    target:                 env.config.target,
    config:                 env.config.module.uiLayerConfig.infoMessageView,
    appComponent:           env.component
}})(OEInfoMessageViewFactory));